import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0AvatarAlert } from '@factorialco/f0-react'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import i18n from 'modules/core/lib/i18n'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'

interface Props {
  loading: boolean
  count: number | string
  hasPendingFteImport: boolean
  hasMissingWorkingTimePercentage: boolean
}

export const FullTimeEquivalent = ({
  loading,
  count,
  hasPendingFteImport,
  hasMissingWorkingTimePercentage,
}: Props) => {
  const [tooltipOpen, toggleTooltip] = useToggle()

  useUnsafeEffect(() => {
    if (!loading && !hasMissingWorkingTimePercentage && Number(count) > 0) {
      track(trackingEvents.accounting.newFinancialWorkspace.workforceHistory.fteDataViewed, {
        source: `employee_costs`,
      })
    }
  }, [loading, hasMissingWorkingTimePercentage, count])

  return (
    <Box style={{ width: '48%' }}>
      <Tooltip.Dialog
        size="small"
        paddingY="s4"
        textAlign="left"
        open={tooltipOpen}
        toggle={toggleTooltip}
        backgroundColor="grey1000"
        attachment="bottom center"
        label={i18n.t('finance.financial_workspace.employee_costs.workforce.fte_tooltip')}
      >
        <Box
          gap="s12"
          paddingTop="s12"
          paddingLeft="s16"
          paddingRight="s12"
          paddingBottom="s20"
          flexDirection="column"
          border={{
            all: {
              style: 'solid',
              width: 's1',
              color: 'grey400',
            },
          }}
          borderRadius={{
            all: 'abs016',
          }}
        >
          <Box flexDirection="row" gap="s4" alignItems="center" justifyContent="spaceBetween">
            <Box flexDirection="row" alignItems="center" gap="s4">
              <Text.Normal size="200" weight="medium" caps>
                {i18n.t('finance.financial_workspace.employee_costs.workforce.fte')}
              </Text.Normal>
              <Icon.Medium icon="info-circle-line" color="grey700" />
            </Box>
            {loading ? null : (
              <>
                {hasPendingFteImport ? (
                  <F0AvatarAlert type="info" size="sm" />
                ) : (
                  hasMissingWorkingTimePercentage && <F0AvatarAlert type="warning" size="sm" />
                )}
              </>
            )}
          </Box>
          <Text.Normal size="400" weight="bold" caps>
            {loading ? (
              <SkeletonValue width="s80" height="s24" />
            ) : hasMissingWorkingTimePercentage ? (
              '-'
            ) : (
              count
            )}
          </Text.Normal>
        </Box>
      </Tooltip.Dialog>
    </Box>
  )
}
